var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMustRead = function SvgMustRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 8.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.536 6.851A7.3 7.3 0 0 0 7 2.188 7.3 7.3 0 0 0 .464 6.85a.44.44 0 0 0 0 .298A7.3 7.3 0 0 0 7 11.813a7.3 7.3 0 0 0 6.536-4.664.44.44 0 0 0 0-.298M7 9.844a2.844 2.844 0 1 1 0-5.688 2.844 2.844 0 0 1 0 5.688"
  })));
};
export default SvgMustRead;